import React from 'react';
import { connect } from 'react-redux';

import Menu from 'controls/menu/Menu';
import Toolbar from 'components/track-events/toolbar/Toolbar';
import List from 'components/track-events/list/List';

class TrackEvents extends React.Component {
  render () {
    return (
      <div>
        <Menu/>
        <Toolbar trackId={ this.props.trackId }/>
        <List trackId={ this.props.trackId }/>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    trackId: parseInt(ownProps.match.params.trackId)
  };
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TrackEvents);
